import { User } from '@/features/users';
import { authAxiosClient } from '@/lib';
import { withLogger } from '@/utils';

import { verifyOtpAPIUrls } from '../data';

type Param = {
  otp: string;
  preAuthToken: string;
};

type TokenResponse = {
  accessToken: string;
  refreshToken: string;
  expiresIn: number;
};

type ResponseData = {
  tokenResponse: TokenResponse;
  userInfo: User;
};

type Return = {
  message: string;
  data: ResponseData;
};

export type VerifyOtp = {
  param: Param;
  return: Return;
};

export const verifyOtp = withLogger(async (param: Param): Promise<Return> => {
  const { data } = await authAxiosClient.post<VerifyOtp['return']>(
    verifyOtpAPIUrls.verifyOtp,
    param,
  );

  return data;
});
